export default function(Vue) {
  Vue.appSettings = {
    settings: {
      // host: 'https://api.pl.indexer.influtool.com/api/'
      host: 'https://api.indexer.influtool.ovh/api/'
    },
    setSetting(name, value) {
      this.settings[name] = value;
    },
    getSetting(name) {
      return this.settings[name];
    }
  };

  if (location.hostname === 'indexer.cz.influtool.com') {
    Vue.appSettings.settings.host = 'https://api.cz.indexer.influtool.com/api/';
  }
  if (location.hostname === 'indexer.cz.influtool.ovh') {
    Vue.appSettings.settings.host = 'https://api.cz.indexer.influtool.ovh/api/';
  }

  if (location.hostname === 'indexer.influtool.ovh') {
    Vue.appSettings.settings.host = 'https://api.indexer.influtool.ovh/api/';
  }

  if (location.hostname === 'indexer.anystar.ovh') {
    Vue.appSettings.settings.host = 'https://api.indexer.anystar.ovh/api/';
  }

  if (location.hostname === 'indexer.anystar.io') {
    Vue.appSettings.settings.host = 'https://api.indexer.anystar.io/api/';
  }

  if (location.hostname === 'indexer.pl.influtool.com') {
    Vue.appSettings.settings.host = 'https://api.pl.indexer.influtool.com/api/';
  }

  Object.defineProperties(Vue.prototype, {
    $appSettings: {
      get() {
        return Vue.appSettings;
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/packages/settings/Settings.js